import { ColDef } from "ag-grid-community";
import { useUsersContext } from "../../../context/UsersContext";
import { buttonsCellRenderer } from "./buttonsCellRenderer";

type Props = {
	setUserId: Function;
	setOpenModalEditDataUser: Function;
	setOpenModalDeleteUser: Function;
	setOpenModalChangePasswordd: Function;
	showContextMenu: Function;
};

export const useTableData = ({
	setUserId,
	setOpenModalEditDataUser,
	setOpenModalDeleteUser,
	setOpenModalChangePasswordd,
	showContextMenu,
}: Props) => {
	const { state } = useUsersContext();
	const columnDefs: ColDef[] = [
		{
			field: "UserName",
			headerName: "UserName",
			sortable: false,
			flex: 1,
			minWidth: 170,
			maxWidth: 170,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "FirstName",
			headerName: "First name",
			sortable: false,
			flex: 1,
			minWidth: 170,
			maxWidth: 170,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "LastName",
			headerName: "Last name",
			sortable: false,
			flex: 1,
			minWidth: 170,
			maxWidth: 170,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Profiles",
			headerName: "Profiles",
			sortable: false,
			flex: 2,
			minWidth: 220,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			cellRenderer: buttonsCellRenderer,
			cellRendererParams: {
				setUserId,
				setOpenModalEditDataUser,
				setOpenModalDeleteUser,
				setOpenModalChangePasswordd,
				showContextMenu,
			},
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: " ",
			sortable: false,
			flex: 1,
			minWidth: 180,
			maxWidth: 180,
		},
	];

	const rows = state.users.map(
		({ UserId, UserName, LastName, FirstName, Profiles }) => ({
			UserId,
			UserName,
			LastName,
			FirstName,
			Profiles: (Profiles as string)?.replaceAll("Profile", ""),
			id: UserId,
		}),
	);
	return { rows, columnDefs };
};
